import TopBar from 'CRM/components/TopBar'
import React from 'react'
import { Display, Wrapper } from '../Main/styles'
import TopBox from './Section/TopBox'
import MidBox from './Section/MidBox'
import CurrentDeposit from './Section/CurrentDeposit'
import ToLastMonth from './Section/ToLastMonth'
import {useIsMobile} from "../../components/IsMobile";

export const Home = () => {
  const IsMobile = useIsMobile();

  return (
    <Display IsMobile={IsMobile}>
      <TopBox />
      <MidBox />
      <CurrentDeposit />
      <ToLastMonth />
    </Display>
  )
}


export default React.memo(Home)